import { styled } from 'styled-components';

import { Box } from '#/components/Box/Box';
import { Button } from '#/components/Button/Button';
import { Dropdown } from '#/components/Dropdown/Dropdown';
import { DropdownMenu } from '#/components/Dropdown/menus/Menu/DropdownMenu';
import { DropdownMenuItem } from '#/components/Dropdown/menus/Menu/Item/DropdownMenuItem';
import { Icon } from '#/components/Icon/Icon';
import { useI18n } from '#/i18n/hooks/useI18n';
import { colors, transition } from '#/theme/theme';

type Props = {
  showBlock: boolean;
  showFlag: boolean;
  handleBlock: () => void;
  handleFlag: () => void;
};

const DropdownItem = styled.div`
  color: ${colors.lightContentGrey};
  transition: all ${transition};

  &:hover {
    color: ${colors.brandBlue};
  }

  display: flex;
  align-items: center;
  padding: 5px 10px 8px;
  font-size: 14px;
  min-width: max-content;
`;

export function ViewUserProfilePageDropdown({
  showBlock,
  showFlag,
  handleBlock,
  handleFlag,
}: Props) {
  const { i18n } = useI18n();

  return (
    <Dropdown
      trigger={
        <Button type="inert" variant="secondary">
          <Icon name="3-dots" size={18} />
        </Button>
      }
      qaId="view-user-profile-dropdown"
    >
      <DropdownMenu>
        <DropdownMenuItem>
          {showFlag && (
            <DropdownItem
              onClick={handleFlag}
              style={{ cursor: 'pointer' }}
              data-qa-id="view-user-profile-report"
            >
              <Box display="inline-block">
                <Icon name="flag" size={16} />
              </Box>
              <Box ml="5px">{i18n('Report This Profile')}</Box>
            </DropdownItem>
          )}
          {showBlock && (
            <DropdownItem
              onClick={handleBlock}
              style={{ cursor: 'pointer' }}
              data-qa-id="view-user-profile-block"
            >
              <Box display="inline-block">
                <Icon name="block" size={16} />
              </Box>
              <Box ml="5px">{i18n('Block This User')}</Box>
            </DropdownItem>
          )}
        </DropdownMenuItem>
      </DropdownMenu>
    </Dropdown>
  );
}
